import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconSettingsGear1: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconSettingsGear1"><Path fillRule="evenodd" clipRule="evenodd" d="M3 16.9341V7.0665L12 1.88477L21 7.06652V16.9338L12 22.1155L3 16.9341ZM8.37502 12C8.37502 9.99797 9.99799 8.375 12 8.375C14.0021 8.375 15.625 9.99797 15.625 12C15.625 14.002 14.0021 15.625 12 15.625C9.99799 15.625 8.37502 14.002 8.37502 12Z" fill="currentColor"/></CentralIconBase>;
});

export default IconSettingsGear1;
